<template>
    <div class="contentBox py-5 px-5 bg-grey" :style="{ borderTop: `15px solid ${accent}` }">
        <img class="size-16 mb-3 p-1" :src="icon" :alt="iconAlt" />

        <h3 class="font-semibold text-2xl text-darkerblue mb-3" v-html="title"></h3>

        <p class="text-lg text-darkerblue subtitle">
            {{ subtitle }}
        </p>

        <router-link :to="routeLink" class="mt-auto">
            <button
                :style="{
                    borderColor: accent,
                    borderWidth: '2px',
                    borderStyle: 'solid',
                }"
                class="bg-white text-gray-800 font-semibold py-2 px-4 mt-8 shadow text-xs flex items-center space-x-2"
            >
                <span>Explore More</span>
                <img class="inline-block h-2 w-2" src="@/assets/img/right_arrow.svg" alt="Right Arrow Icon" />
            </button>
        </router-link>
    </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    accent: {
        type: String,
        required: true,
    },
    title: {
        type: String,
        required: true,
    },
    subtitle: {
        type: String,
        required: true,
    },
    icon: {
        type: String,
        required: true,
    },
    iconAlt: {
        type: String,
        required: true,
    },
    studyId: {
        type: String,
        required: true,
    },
});

const routeLink = computed(() => {
    return `/study/${props.studyId}`;
});
</script>

<style scoped>
.contentBox {
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
}
</style>
